import { render } from "./SegmentColor.vue?vue&type=template&id=b3ec30aa&scoped=true"
import script from "./SegmentColor.vue?vue&type=script&lang=js"
export * from "./SegmentColor.vue?vue&type=script&lang=js"

import "./SegmentColor.vue?vue&type=style&index=0&id=b3ec30aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3ec30aa"]])

export default __exports__